import { render, staticRenderFns } from "./ModalDeleteProduct.vue?vue&type=template&id=f4cd7ab6&scoped=true&lang=pug&"
import script from "./ModalDeleteProduct.vue?vue&type=script&lang=ts&"
export * from "./ModalDeleteProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cd7ab6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VListItem,VRow})
